import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import './SolicitarServico.css';
import { 
  buscarDadosViagemPeloCliente, 
  buscarDadosPontoById, 
  buscarPilotoById } from '../servicos/listagemServico';

import Cookies from 'js-cookie';

import { 
  solicitarServicoEAtualizarStatusPilotoByDadosPiloto,
  atualizarStatusPilotoByDadosPiloto,
  atualizarStatusViagemPeloCliente
} from '../servicos/cadastroServico';
import LoadingIndicator from '../components/LoadingIndicator'

function SolicitarServico() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [loadingIndicator, setLoadingIndicator] = useState(true);

  const [ponto, setPonto] = useState(null);
  const [objServicoSolicitado, setObjServicoSolicitado] = useState(null);
  const [pilotoDisponivelMaisProximo, setPilotoDisponivelMaisProximo] = useState(null);
  // const [loading, setLoading] = useState(true);
  const [aguardandoConfirmacao, setAguardandoConfirmacao] = useState(false);
  const [statusPiloto, setStatusPiloto] = useState('');
  const [viagem, setViagem] = useState('');
  const [statusViagem, setStatusViagem] = useState(''); 

  const cookies = Cookies.get();
  const dadosCookies = cookies.dadosCookies ? JSON.parse(cookies.dadosCookies) : null;





  // ---- Busca inicial
  const carregarDados = async () => {

    console.log('!! Entrou em carregarDados em SolicitarServico.js !!!');
    setLoadingIndicator(true);

    try {
      const dados = await buscarDadosPontoById(id, dadosCookies);

      console.log('Dados recebidos: ');
      console.log(dados);

      if (dados.quantidadePilotosProximos === 0) {
        alert('Nenhum piloto disponível neste ponto para o serviço ' + dados.obj_servico_solicitado.nome);
        navigate(-1);
        return;
      }

      console.log('Ponto: ');
      console.log(dados.dados_ponto_mototaxi);

      setPonto(dados.dados_ponto_mototaxi);
      setObjServicoSolicitado(dados.obj_servico_solicitado);
      setPilotoDisponivelMaisProximo(dados.piloto_disponivel_mais_proximo);

      const statusAtual = dados.piloto_disponivel_mais_proximo?.nome_status || '';
      setStatusPiloto(statusAtual);

      console.log('Status atual do piloto: ');
      console.log(statusAtual);

      if (statusAtual === 'PILOTO DISPONÍVEL') {
        await alternarStatus(dados.piloto_disponivel_mais_proximo, 'PILOTO SOLICITADO');
        setAguardandoConfirmacao(true);

      } else if (statusAtual === 'PILOTO SOLICITADO') {
        setAguardandoConfirmacao(true);

      } else if (statusAtual === 'PILOTO EM VIAGEM') {
        navigate(`/ir-ate-o-cliente/${dados.piloto_disponivel_mais_proximo.id}`);
      }

    } catch (erro) {
      console.error('Erro ao buscar dados:', erro);
      setPonto(null);
    } finally {
      // setLoading(false);
      setLoadingIndicator(false);
    }
  };

  // ---- Verifica status do piloto
  const verificarStatusPiloto = async () => {

    console.log('Entrou em verificarStatusPiloto...');
    setLoadingIndicator(true);

    if (!pilotoDisponivelMaisProximo){
      setLoadingIndicator(false);
      return;
    } 

    try {

      console.log('Preparando para buscar o piloto by id...');

      const piloto = await buscarPilotoById(pilotoDisponivelMaisProximo.id);
      const statusPiloto = piloto.dadosPiloto.objPiloto.nome_status;

      console.log('Piloto buscado: ');
      console.log(piloto);

      setStatusPiloto(statusPiloto);

      const novosDadosCookies = {
        ...dadosCookies,
        piloto: piloto
      };
      Cookies.set('dadosCookies', JSON.stringify(novosDadosCookies), { expires: 60 });

      console.log('Status do piloto: ');
      console.log(statusPiloto);

      if (statusPiloto === 'PILOTO EM VIAGEM') {

        console.log('Vai redirecionar para mapa piloto vindo...');

        navigate(`/mapa-piloto-vindo`);
      }

    } catch (erro) {
      console.error('Erro ao verificar status do piloto:', erro);
    } finally {
      setLoadingIndicator(false);
    }
  };

  // ---- Atualiza status
  const alternarStatus = async (dadosPiloto, statusAtual) => {

    console.log('!!! Entrou em alternarStatus....');
    setLoadingIndicator(true);

    const mapaStatus = { 'PILOTO SOLICITADO': 'solicitado' };
    const novoStatus = mapaStatus[statusAtual.trim()];

    if (!novoStatus) return;

    try {

      console.log('!!!! Prepara para solicitar o serviço e atualizar status do piloto....');

      const response = await solicitarServicoEAtualizarStatusPilotoByDadosPiloto(
        dadosPiloto, novoStatus, dadosCookies, id
      );

      console.log('Response recebido: ');
      console.log(response);

      setViagem(response.objViagem);

      // vamos colocar os dados da viagem nos cookies
      const novosDadosCookies = {
        ...dadosCookies,
        objViagem: response.objViagem
      };
      Cookies.set('dadosCookies', JSON.stringify(novosDadosCookies), { expires: 60 });

    } catch (e) {
      console.error('Erro ao atualizar status:', e);
    } finally {
      setLoadingIndicator(false);
    }
  };


  const handleBuscarDadosViagemPeloCliente = async () => {

    console.log('******************');
    console.log('!!! Entrou em handleBuscarDadosViagemPeloCliente....');
    setLoadingIndicator(true);

    console.log('! Entrou em handleBuscarDadosViagemPeloCliente...');
  
    const cookies = Cookies.get();
    const dadosCookies = cookies.dadosCookies ? JSON.parse(cookies.dadosCookies) : null;
  
    if (!dadosCookies) {
      console.warn("Dados do cliente não encontrados nos cookies!");
      setLoadingIndicator(false);
      return;
    }
  
    console.log('dadosCookies antes: ');
    console.log(dadosCookies);

    // 🔹 Verifica se a viagem foi cancelada pelo piloto
    if (dadosCookies?.objViagem?.nome_status === 'VIAGEM CANCELADA PELO PILOTO') {
      console.warn('Viagem foi cancelada pelo piloto! Recarregando dados...');
      carregarDados();
      return;
    }
  
    try {
      console.log('Preparando para buscar dados da viagem....');
  
      const response = await buscarDadosViagemPeloCliente(dadosCookies);
  
      console.log('==================');
      console.log('==================');
      console.log('Response do buscar viagem: ');
      console.log(response);
  
      // Atualiza os cookies com os dados corretos da viagem
      const novosDadosCookies = {
        ...dadosCookies,
        objViagem: response.objViagem,
      };
      Cookies.set('dadosCookies', JSON.stringify(novosDadosCookies), { expires: 60 });

      // 🔹 Atualiza status da viagem
      if (response?.objViagem?.nome_status) {
        setStatusViagem(response.objViagem.nome_status);
      }

      const cookies2 = Cookies.get();
      const dadosCookies2 = cookies2.dadosCookies ? JSON.parse(cookies2.dadosCookies) : null;

      console.log('cookies atualizados: ');
      console.log(dadosCookies2);
  
  
      // 🔹 Verifica status da viagem
      if (response?.objViagem?.nome_status === 'VIAGEM FINALIZADA') {
        console.warn('Viagem chegou ao fim!!!');
        alert('Sua viagem chegou ao fim. Obrigado por chamar o Melgs!');
        navigate('/');
      } else if (response?.objViagem?.nome_status === 'VIAGEM CANCELADA PELO PILOTO') {
        console.warn('Viagem cancelada pelo piloto! vamos buscar um novo piloto!');
        alert('Sua viagem foi cancelada pelo piloto. Faça uma nova solicitação.');
        navigate(-1);
        return;
        // navigate(`/`);
        // navigate(`/solicitar-servico/${id}`);
        // carregarDados();
      }      
  
    } catch (e) {
      console.error('Erro ao buscar os dados da viagem:', e);
    } finally {
      setLoadingIndicator(false);
    }
  };
  

  // ---- Polling para buscar dados da viagem
  useEffect(() => {
    const interval = setInterval(() => {
      handleBuscarDadosViagemPeloCliente();
    }, 10000);

    return () => clearInterval(interval);
  }, []);



  // ---- Efeito inicial
  useEffect(() => {
    carregarDados();
  }, [id]);

  // ---- Polling
  useEffect(() => {
    let intervalo;
    if (aguardandoConfirmacao) {
      intervalo = setInterval(() => {
        verificarStatusPiloto();
      }, 25000);
    }
    return () => clearInterval(intervalo);
  }, [aguardandoConfirmacao, pilotoDisponivelMaisProximo]);




  const cancelarSolicitacao = async () => {

    console.log('*******');
    console.log('Entrou em cancelarSolicitacao....');
    setLoadingIndicator(true);

    try {
      const cookies = Cookies.get();
      const dadosCookies = cookies.dadosCookies ? JSON.parse(cookies.dadosCookies) : null;

      console.log('cookies: ');
      console.log(dadosCookies);
  
      if (!dadosCookies) {
        alert('Não foi possível localizar os dados do piloto.');
        return;
      }
  
      // Atualiza status do piloto
      console.log('!!! Preparando para atualizar o status do piloto... ');

      await atualizarStatusPilotoByDadosPiloto(dadosCookies, 'indisponivel');

      console.log('ok, status do piloto atualizado! ');
  
      // Recarrega cookies após a atualização
      const cookiesAtualizados = Cookies.get();

      const dadosCookiesAtualizados = cookiesAtualizados.dadosCookies 
        ? JSON.parse(cookiesAtualizados.dadosCookies) 
        : null;
  
      if (!dadosCookiesAtualizados) {
        alert('Não foi possível atualizar os dados do piloto.');
        return;
      }
  
      // Atualiza status da viagem
      console.log('!!! Preparando para atualizar o status da viagem....');

      const respostaViagem = await atualizarStatusViagemPeloCliente(
        dadosCookies,
        'VIAGEM CANCELADA PELO CLIENTE'
      );
  
      console.log('Resposta status viagem: ', respostaViagem);
  
      // Atualiza objViagem nos cookies
      const novoObjetoViagem = respostaViagem?.objViagemAlterarStatus || null;
      if (!novoObjetoViagem) {
        alert('Não foi possível atualizar a viagem.');
        return;
      }

      console.log('ok, status da viagem atualizado! ');
  
      const novosDadosCookies2 = {
        ...dadosCookiesAtualizados,
        dadosPiloto: {
          ...dadosCookiesAtualizados.dadosPiloto,
          objViagem: novoObjetoViagem
        }
      };
  
      Cookies.set('dadosCookies', JSON.stringify(novosDadosCookies2), { expires: 60 });

      console.log('cookies atualizados: ');
      console.log(novosDadosCookies2);
  
      navigate(`/`);


    } catch (e) {
      console.error('Erro ao cancelar a solicitação:', e);
      alert('Não foi possível cancelar a solicitação.');
    }
  };
  


// Chama inativarPiloto se o piloto não aceitar em 30 segundos
useEffect(() => {
  if (statusPiloto === 'PILOTO SOLICITADO' && aguardandoConfirmacao && pilotoDisponivelMaisProximo) {
  
    console.log('⏱️ Iniciando contagem para inativar piloto...');

    // se passar o tempo, entra aqui
    const timeout = setTimeout(async () => {
      setLoadingIndicator(true);
      try {
        console.warn('⛔ Piloto não respondeu. Inativando piloto e buscando outro...');

        await atualizarStatusPilotoByDadosPiloto(dadosCookies, 'indisponivel');

        alert('O piloto não respondeu. Tente novamente.');
        // navigate(); // ou redirecionar para outra tela
        carregarDados();
      } catch (erro) {
        console.error('Erro ao inativar piloto:', erro);
      } finally {
        setLoadingIndicator(false);
      }
    }, 40000); // 40 segundos se piloto não aceitar

    // Limpa timeout se o piloto mudar de status antes dos 30s
    return () => clearTimeout(timeout);
  }
}, [statusPiloto, aguardandoConfirmacao, pilotoDisponivelMaisProximo]);



  // ---- Tela de loading
  // if (loading) {
  //   return (
  //     <div className="d-flex justify-content-center align-items-center vh-100 px-3">
  //       <div className="text-center">
  //         <div className="spinner-border text-primary mb-3" role="status" style={{ width: '2.8rem', height: '2.8rem' }}>
  //           <span className="visually-hidden">Carregando...</span>
  //         </div>
  //         <p className="fw-bold">Carregando dados...</p>
  //       </div>
  //     </div>
  //   );
  // }

  if (!ponto) {
    return (
      <div className="container text-center mt-5">
        <div className="alert alert-danger">Ponto não encontrado</div>
        <button onClick={() => navigate(-1)} className="btn btn-outline-primary mt-3">
          ← Voltar
        </button>
      </div>
    );
  }

  // ---- Tela aguardando confirmação
  if (aguardandoConfirmacao) {
    return (
      <div className="container-fluid mt-5 px-3">
        <div className="row justify-content-center">
          <div className="col-12 col-md-8 col-lg-6">
            {/* CARD 1 - Título */}
            <div className="card mt-4 shadow-sm border-0 rounded-4">
              <div className="card-body text-center">
                <h2 className="fw-bold" style={{ color: '#0A3D91', fontSize: '1.4rem' }}>
                  Aguardando confirmação do piloto...
                </h2>
              </div>
            </div>

            {/* CARD 2 - Dados */}
            <div className="card mt-4 shadow-sm border-0 rounded-4">
              <div className="card-body text-center">
                <p><strong>Piloto:</strong> {pilotoDisponivelMaisProximo?.name}</p>
                <p><strong>Latitude:</strong> {pilotoDisponivelMaisProximo?.latitude}</p>
                <p><strong>Destino:</strong> {viagem.descricao_endereco_destino}</p>
                <p className="mb-4"><strong>Status:</strong> {statusPiloto}</p>

                {/* <button className="btn btn-danger btn-lg w-100" onClick={() => navigate(-1)}>
                  CANCELAR SOLICITAÇÃO
                </button> */}

                <button 
                className="btn btn-danger btn-lg w-100 w-md-auto mt-2 mt-md-0"
                onClick={() => {
                  cancelarSolicitacao();
                }}
              >
                ❌ CANCELAR SOLICITAÇÃO
              </button>


              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }


  if (loadingIndicator) {
    return <LoadingIndicator fullscreen message="Aguarde..." />;
  }


  // ---- Tela principal
  return (
    <div className="container-fluid mt-5 px-3">
      <div className="row justify-content-center">
        <div className="col-12 col-md-8 col-lg-6">
          <div className="card shadow-lg border-0 rounded-4 p-4">
            <div className="text-center mb-4">
              <h4 className="fw-bold text-primary mb-1">Solicitar Serviço</h4>
              <p className="text-muted small mb-0">
                Confirme os dados abaixo antes de continuar
              </p>
            </div>

            <div className="mb-4">
              <div className="d-flex align-items-center mb-3">
                <i className="bi bi-building text-secondary me-2" style={{ fontSize: '1.5rem' }}></i>
                <span className="fw-semibold">{ponto.user.name}</span>
              </div>

              <div className="d-flex align-items-center">
                <i className="bi bi-briefcase-fill text-secondary me-2"></i>
                <span className="fw-medium">
                  Serviço: <strong>{objServicoSolicitado.nome}</strong>
                </span>
              </div>
            </div>

            <div className="text-center">
              <button onClick={() => navigate(-1)} className="btn btn-outline-primary w-100">
                ← Voltar
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default SolicitarServico;
